export type ValueOf<T> = T[keyof T];

export const UserType = Object.freeze({
  PRIVATO: 'PRIVATO',
  PARTITA_IVA: 'PARTITA_IVA'
});

export type UserTypeValues = ValueOf<typeof UserType>;
export type USerTypeKeys = keyof typeof UserType;
